import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';
import { Manifest } from 'services/action';
import { Skeletons } from 'ui/components/skeleton';

import LegsCard from './legs.card';
import LegsDetail from './legs.detail';

const initialState = {
  legs: [],
  showing: null,
};

export const SectionLegs = ({ manifest, loading, onLegChanges, privilege }) => {
  const Dispatch = useDispatch();
  const [{ legs, showing }, setState] = React.useState(initialState);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Manifest.GetLegs']
  );
  const dummy = Array.from({ length: 10 }, (v, i) => i);
  const [, forceUpdate] = React.useReducer((x) => x + 1, 0);

  const $loadLegs = async () => {
    const req = await Dispatch(Manifest.$getLegs(manifest?.id));

    if (req?.message === 'success') {
      setState((prevState) => ({
        ...prevState,
        legs: req?.data,
        showing: null,
      }));

      initShowing(req?.data, showing);
    }

    forceUpdate()
  };

  const initShowing = (legs, legShowed) => {
    if (legShowed) {
      // harus activin balik yang terpilih
      const show = _.filter(legs, function (l) {
        return l?.id === legShowed?.id;
      });

      if (show?.length > 0) {
        $handleShowing(show[0]);
        return;
      }
    }

    let departure = _.where(legs, { status: 'departed' });
    let arrive = _.where(legs, { status: 'arrived', type: 'drop_point' });

    if (arrive?.length > 0) {
      $handleShowing(arrive[0]);
    } else if (departure?.length > 0) {
      $handleShowing(departure[0]);
    } else if (legs?.length > 0) {
      $handleShowing(legs[0]);
    }
  };

  const $handleMoveDown = (id) => {
    let newData = [...legs];
    let index = newData.findIndex((e) => e.id === id);

    if (index !== -1 && index < newData.length - 1) {
      let el = newData[index];
      newData[index] = newData[index + 1];
      newData[index + 1] = el;
    }
    $sortLegs(newData);
  };

  const $handleMoveUp = (id) => {
    let newData = [...legs];
    let index = newData?.findIndex((e) => e.id === id);

    if (index > 0) {
      let el = newData[index];
      newData[index] = newData[index - 1];
      newData[index - 1] = el;
    }

    $sortLegs(newData);
  };

  const $sortLegs = async (e) => {
    let n = [];

    if (e) {
      _.each(e, function (d) {
        n.push(d?.id);
      });
    }

    const payload = {
      legs: n,
    };
    const req = await Dispatch(Manifest.$sort(manifest?.id, payload));

    if (req?.message === 'success') {
      $loadLegs();
      if (onLegChanges) onLegChanges();
    }
  };

  const $handleShowing = (e) => {
    setState((prevState) => ({
      ...prevState,
      showing: e,
    }));
  };

  React.useEffect(() => {
    if (!manifest) return;
    $loadLegs();
  }, [manifest]);

  return (
    <div className="p-0 p-md-3 ps-md-0 ">
      <div className="row">
        <div className="col-md-6 mb-3 mb-md-0">
          <div className="card legs rounded-2 bg-white">
            <div className="card-header-gray p-3 border-bottom">
              <h3 className="card-title dx-card-title m-0 p-0">
                Rute Pengiriman
              </h3>
            </div>
            <div className="card-body p-0 position-relative">
              {loading || StateLoading ? (
                dummy?.map((d, i) => (
                  <div className="mb-3" key={i}>
                    <Skeletons height="30px" width="100%" />
                  </div>
                ))
              ) : (
                <div className="leg-list">
                  {legs?.map((d, i) => (
                    <LegsCard
                      data={d}
                      key={i}
                      active={showing?.id === d?.id}
                      status={manifest?.status}
                      keys={i + 1}
                      moveDown={(i) => $handleMoveDown(i)}
                      moveUp={(i) => $handleMoveUp(i)}
                      onClick={$handleShowing}
                      privilege={privilege}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-md-6 mb-3 mb-md-0">
          <LegsDetail
            manifest={manifest}
            legs={showing}
            handleReload={$loadLegs}
            onLegChanges={onLegChanges}
            loading={loading || StateLoading}
            privilege={privilege}
          />
        </div>
      </div>
    </div>
  );
};
